import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";

export interface LabourSupplierMaster {
  id: string;
  contactPersonName: string;
  firmName: string;
  gstNumber: string;
  contactPhone: string;
  contactEmail: string;
  registeredAddress: string;
  bankAccountNumber: string;
  bankIfsc: string;
  bankName: string;
  bankAccountName: string;
  status: string;
  createdAt: string;
}

async function parseError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const j = JSON.parse(text) as { error?: string };
    if (j.error) return j.error;
  } catch {
    /* ignore */
  }
  return text || `Request failed (${res.status})`;
}

export async function fetchLabourSuppliers(): Promise<LabourSupplierMaster[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/labour-suppliers`);
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<LabourSupplierMaster[]>;
}

export async function createLabourSupplier(
  body: Omit<LabourSupplierMaster, "id" | "status" | "createdAt">,
): Promise<LabourSupplierMaster> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/labour-suppliers`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<LabourSupplierMaster>;
}

export async function updateLabourSupplier(
  id: string,
  body: Partial<Omit<LabourSupplierMaster, "id" | "status" | "createdAt">>,
): Promise<LabourSupplierMaster> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/labour-suppliers/${encodeURIComponent(id)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<LabourSupplierMaster>;
}

export async function deactivateLabourSupplier(id: string): Promise<void> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/labour-suppliers/${encodeURIComponent(id)}/deactivate`, {
    method: "POST",
  });
  if (!res.ok) throw new Error(await parseError(res));
}
